import React from "react";
import "../template-file-css/document-file-template.css";

export const NBT_SchoolConsultationForm = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='NBT_SchoolConsultationForm' className='file-pdf-document'>
            <div className='file-template'>
                
                
                
                <p>
                    <center><h3>SCHOOL CONSULTATION FORM </h3></center>
                </p>
                <p>
                    As the parent/guardian of &nbsp;
                    <input type="text"  id="txtTelephone2" name="txtTelephone2" className="add-only w-200 custom-add-only" />&nbsp;
                    I,&nbsp;
                    <input type="text"  id="txtTelephone3" name="txtTelephone3" className="add-only w-200 custom-add-only" />&nbsp;
                    hereby give permission for New Beginnings Today, LLC to have group and/or individual therapy with my child. The sessions will take
                    place at
                    &nbsp;<input type="text"  id="txtTelephone4" name="txtTelephone4" className="add-only w-200 custom-add-only" />&nbsp;
                    School. In addition, I give New Beginnings Today, LLC permission to provide any additional support to my child as needed at school.
                </p>
                <h3>TREATMENT TEAM:
                </h3>
                <table>
                    <tr>
                        <td className="w-375">
                            <span className="eleHeader">Team Leader -</span>
                            <input type="text" id="txtTeamLeader" name="txtTeamLeader" className="add-only" />
                        </td>
                        <td className="w-375">
                            <span className="eleHeader">Paraprofessional -</span>
                            <input type="text" id="txtParaprofessional" name="txtParaprofessional" className="add-only" />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className="w-375 signature">&nbsp;</td>
                        <td className="w-375 signature">&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-375 small">Print parent/guardian name:</td>
                        <td className="w-375 small">Date:</td>
                    </tr>
                    <tr>
                        <td className="w-375 signature">&nbsp;</td>
                        <td className="w-375 signature">&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-375 small">Signature of parent/guardian:</td>
                        <td className="w-375 small">Date:</td>
                    </tr>
                    <tr>
                        <td className="w-375 signature">&nbsp;</td>
                        <td className="w-375 signature">&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-375 small">Witness:</td>
                        <td className="w-375 small">Date:</td>
                    </tr>
                </table> 
            </div>
        </form>
    )
}